import { useMutation, useQueryClient } from '@tanstack/react-query';
import * as api from '../api/mail.api';

export const useMessageAction = () => {
  const q = useQueryClient();
  return useMutation({
    mutationFn: api.mailboxMessageAction,
    onSuccess: (_, vars) => {
      const { mailboxId, folder } = vars;
      q.invalidateQueries(['mail','messages', mailboxId, folder]);
      q.invalidateQueries(['mail','folders', mailboxId]);
      q.invalidateQueries(['mail','thread']);
      q.invalidateQueries(['mail','messages']);
      q.invalidateQueries(['mail','unified']);
    }
  });
};
